import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../../Auth/CheckEmail/CheckEmail.scss';
import LogoHome from '../../../components/Logo/LogoHome';

const BillingSuccess = ({ redirectTime = 8 }) => {
    const { t, i18n } = useTranslation();
    const history = useHistory();

    const [seconds, setSeconds] = useState(redirectTime);

    useEffect(() => {
        document.title = t('pages.billing_success.doc_title');
    }, [t, i18n.language]);

    // useEffect(() => {
    //     if (seconds > 0) {
    //         const timer = setInterval(() => {
    //             setSeconds(prev => prev - 1);
    //         }, 950);
    //         return () => clearInterval(timer);
    //     } else {
    //         history.push('/diagrams');
    //     }
    // }, [seconds, history]);

    return (
        <div className="check-email-box">
            <LogoHome />
            <div className='check-email verified'>
                <svg width="62px" height="62px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <circle cx="12" cy="12" r="10" stroke="#f7f7f7" strokeWidth="1.25"></circle>
                        <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#f7f7f7" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"></path>
                    </g>
                </svg>

                <div className="check-email-title verified">{t('pages.billing_success.heading')}</div>

                <div className='check-email-text-wrap verified'>
                    <p className="check-email-text">{t('pages.billing_success.subtitle')}</p>
                    {/* <p className="check-email-text">All features are now unlocked and ready to use.</p> */}
                </div>

                <a href="/diagrams" className="check-email-action verified">
                    <span>{t('pages.billing_success.cta')}</span>
                </a>

                {/* <div className='check-email-text-wrap-bottom'>
                    <p className="check-email-text-bottom verified">Redirecting in {seconds} seconds</p>
                </div> */}
            </div>
        </div>
    );
};

export default BillingSuccess;
